import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ChatRoom from '../components/ChatRoom';
import JoinForm from '../components/JoinForm';

const RoomPage = () => {
  const { roomId } = useParams();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [isJoined, setIsJoined] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const queryName = params.get('username')?.trim() || '';
    
    if (queryName.length > 0) {
      setUsername(queryName);
      setIsJoined(true);
    }
  }, []);

  const handleJoin = (e) => {
    e.preventDefault();
    if (username.trim()) {
      setIsJoined(true);
    }
  };

  const handleLeave = () => {
    setIsJoined(false);
    setUsername('');
  };

  if (!isJoined) {
    return (
      <JoinForm
        roomId={roomId}
        username={username}
        onUsernameChange={(e) => setUsername(e.target.value)}
        onSubmit={handleJoin}
      />
    );
  }

  return (
    <div className="room-container">
      <div className="room-header">
        <div className="room-info">
          <h1>Комната: {roomId}</h1>
        </div>
        <button className="leave-btn" onClick={handleLeave}>
          <img src="/assets/images/logout.svg" alt="Logout" />
        </button>
      </div>
      
      <ChatRoom roomId={roomId} requestedUsername={username} />
    </div>
  );
};

export default RoomPage;